import { IconLock } from "@tabler/icons-react";

import { Text } from "@fragments";
import CommunityPlansAvailableTable from "@components/CommunityPlansAvailableTable";

import "./styles.scss";

export default function GroupNoAccess({ communityId, availability }) {
    return (
        <div className="group-no-access">
            <div className="group-no-access__icon">
                <IconLock size={28} />
            </div>
            <Text.h3 contrast={8} className="group-no-access__title">
                Grupo restrito
            </Text.h3>
            <Text.span contrast={4} className="group-no-access__subtitle">
                Para ter acesso a este grupo, assine um dos planos abaixo.
            </Text.span>
            <div className="group-no-access__plans">
                <CommunityPlansAvailableTable
                    communityId={communityId}
                    availability={availability}
                />
            </div>
        </div>
    );
}
